<template>
  <div id="pct-content-tab">
    <b-row cols="1">
      <b-col>
        <b-form-group>
          <label for="name" class="title-name mt-2 font-medium-5">
            <span>Privilege Name</span>&nbsp;
            <span class="text-gray">(ไม่ควรเกิน 80 อักขระ)</span>
          </label>
          <div v-if="!formModal.isLayoutPrivilegeNameShow">
            <b-button
              class="btn-add-layout"
              @click="addLayout(showLayout.PRIVILEGE_NAME)"
            >
              <div class="d-flex align-items-center justify-content-center">
                <add-icon /> <span class="ml-2">{{ "Add" }}</span>
              </div>
            </b-button>
          </div>
          <b-input-group
            v-else
            :append="`${formModal.privilegeName.length}`"
            class="input-append-custom"
          >
            <b-form-input
              id="name"
              ref="privilegeNameTextEditor"
              v-model="formModal.privilegeName"
              placeholder="ระบุ"
              :formatter="formatName"
              @focus="onFocus('privilegeNameTextEditor')"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label for="desc" class="title-name mt-2 font-medium-5"
            >Description</label
          >
          <div v-if="!formModal.isLayoutDescShow">
            <b-button
              class="btn-add-layout"
              @click="addLayout(showLayout.PRIVILEGE_DESC)"
            >
              <div class="d-flex align-items-center justify-content-center">
                <add-icon /> <span class="ml-2">{{ "Add" }}</span>
              </div>
            </b-button>
          </div>
          <b-form-input
            v-else
            id="desc"
            ref="privilegeDescTextEditor"
            v-model="formModal.privilegeDesc"
            placeholder="ระบุ"
            @focus="onFocus('privilegeDescTextEditor')"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <label class="title-name mt-2 font-medium-5">Remark</label>
        <div v-if="!formModal.isLayoutRemarkShow">
          <b-button
            class="btn-add-layout"
            @click="addLayout(showLayout.PRIVILEGE_REMARK)"
          >
            <div class="d-flex align-items-center justify-content-center">
              <add-icon /> <span class="ml-2">{{ "Add" }}</span>
            </div>
          </b-button>
        </div>
        <quill-editor
          v-else
          id="quillEditorRemark"
          ref="myQuillRemark"
          v-model="formModal.privilegeRemark"
          class="custom-quill-editor"
          :options="customQuillOption"
          @focus="onFocus('remarkTextEditer')"
        />
        <color-code-pickr
          v-if="formModal.privilegeRemark"
          title="Background Remark"
          :model-value="formModal.remarkBgColor"
          id="remarkBg"
          @update:modelValue="
            (newValue) => (formModal.remarkBgColor = newValue)
          "
        />
      </b-col>

      <b-col>
        <label class="title-name mt-2 font-medium-5">Term and Conditions</label>
        <div v-if="!formModal.isLayoutTermShow">
          <b-button
            class="btn-add-layout"
            @click="addLayout(showLayout.PRIVILEGE_TERM)"
          >
            <div class="d-flex align-items-center justify-content-center">
              <add-icon /> <span class="ml-2">{{ "Add" }}</span>
            </div>
          </b-button>
        </div>
        <quill-editor
          v-else
          id="quillEditor"
          ref="myQuill"
          v-model="formModal.privilegeTerm"
          class="custom-quill-editor"
          :options="customQuillOption"
          @focus="onFocus('privilegeTermEditor')"
        />
      </b-col>
    </b-row>
    <b-row cols="1" class="mt-2">
      <b-col>
        <b-form-checkbox
          id="isExpire"
          v-model="formModal.isExpire"
          name="isExpire"
          :value="true"
          :unchecked-value="false"
          class="custom-checkbox-square custom-control-success"
        >
          <div class="font-medium-5">Expire</div>
        </b-form-checkbox>
      </b-col>
      <b-col v-if="formModal.isExpire == true">
        <div class="pl-2">
          <div>
            <!-- <label class="title-name font-medium-5 bypass">Expire Date</label> -->
            <b-row>
              <b-col cols="12">
                <div>
                  <div class="d-flex">
                    <b-col class="p-0 mr-2">
                      <div class="p-0 p-relative mr-2">
                        <calendar-picker-icon
                          class="icon-calendar bypass"
                          :class="
                            formModal.expireDate.date
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                        <flat-pickr
                          :id="'expireDate-date'"
                          v-model="formModal.expireDate.date"
                          class="form-control bg-date"
                          :class="
                            formModal.expireDate.date ? 'date-selected' : null
                          "
                          :config="flatpickrDateConfig"
                          placeholder="-select-"
                          autocomplete="off"
                          :disabled="formModal.expireType != 1"
                          @on-open="onFocus('expTextEditor')"
                        />
                      </div>
                    </b-col>
                    <b-col class="p-0 ml-2">
                      <div class="p-0 p-relative">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            formModal.expireDate.time
                              ? 'date-selected-icon'
                              : null
                          "
                        />
                        <flat-pickr
                          id="expireDate-time"
                          v-model="formModal.expireDate.time"
                          class="form-control bg-date"
                          :class="
                            formModal.expireDate.time ? 'date-selected' : null
                          "
                          :config="flatpickrTimeConfig"
                          :placeholder="'-select-'"
                          autocomplete="off"
                          :disabled="formModal.expireType != 1"
                          @on-open="onFocus('expTextEditor')"
                        />
                      </div>
                    </b-col>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- hold ไว้ก่อน -->
          <!-- <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio
              v-model="formModal.expireType"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              class="custom-radio-group mt-1"
              value="1"
            >
              <div>
                <label class="title-name font-medium-5 bypass"
                  >Expire Date</label
                >
                <b-row>
                  <b-col cols="12">
                    <div>
                      <div class="d-flex">
                        <b-col class="p-0 mr-2">
                          <div class="p-0 p-relative mr-2">
                            <calendar-picker-icon
                              class="icon-calendar bypass"
                              :class="
                                formModal.expireDate.date
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                            <flat-pickr
                              :id="'expireDate-date'"
                              v-model="formModal.expireDate.date"
                              class="form-control bg-date"
                              :class="
                                formModal.expireDate.date
                                  ? 'date-selected'
                                  : null
                              "
                              :config="flatpickrDateConfig"
                              placeholder="-select-"
                              autocomplete="off"
                              :disabled="formModal.expireType != 1"
                              @on-open="onFocus('expTextEditor')"
                            />
                          </div>
                        </b-col>
                        <b-col class="p-0 ml-2">
                          <div class="p-0 p-relative">
                            <clock-picker-icon
                              class="icon-calendar date-picker-icon bypass"
                              :class="
                                formModal.expireDate.time
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                            <flat-pickr
                              id="expireDate-time"
                              v-model="formModal.expireDate.time"
                              class="form-control bg-date"
                              :class="
                                formModal.expireDate.time
                                  ? 'date-selected'
                                  : null
                              "
                              :config="flatpickrTimeConfig"
                              :placeholder="'-select-'"
                              autocomplete="off"
                              :disabled="formModal.expireType != 1"
                              @on-open="onFocus('expTextEditor')"
                            />
                          </div>
                        </b-col>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-form-radio>
            <b-form-radio
              v-model="formModal.expireType"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              class="custom-radio-group mt-1"
              value="2"
            >
              <div>
                <label class="title-name font-medium-5 bypass">Redeeming</label>
                <b-row>
                  <b-col cols="12">
                    <div>
                      <div class="d-flex">
                        <b-col class="p-0 mr-2">
                          <div class="p-0 p-relative mr-2">
                            <calendar-picker-icon
                              class="icon-calendar bypass"
                              :class="
                                formModal.redeemDate.date
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                            <flat-pickr
                              :id="'redeemDate-date'"
                              v-model="formModal.redeemDate.date"
                              class="form-control bg-date"
                              :class="
                                formModal.redeemDate.date
                                  ? 'date-selected'
                                  : null
                              "
                              :config="flatpickrDateConfig"
                              placeholder="-select-"
                              autocomplete="off"
                              :disabled="formModal.expireType != 2"
                              @on-open="onFocus('expTextEditor')"
                            />
                          </div>
                        </b-col>
                        <b-col class="p-0 ml-2">
                          <div class="p-0 p-relative">
                            <clock-picker-icon
                              class="icon-calendar date-picker-icon bypass"
                              :class="
                                formModal.redeemDate.time
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                            <flat-pickr
                              id="redeemDate-time"
                              v-model="formModal.redeemDate.time"
                              class="form-control bg-date"
                              :class="
                                formModal.redeemDate.time
                                  ? 'date-selected'
                                  : null
                              "
                              :config="flatpickrTimeConfig"
                              :placeholder="'-select-'"
                              autocomplete="off"
                              :disabled="formModal.expireType != 2"
                              @on-open="onFocus('expTextEditor')"
                            />
                          </div>
                        </b-col>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-form-radio>
          </b-form-group> -->
        </div>
      </b-col>
    </b-row>
    <b-row cols="2">
      <b-col v-if="formModal.templateSelect !== templateType.TYPE2 && formModal.templateSelect !== templateType.TYPE3">
        <label class="title-name mt-2 font-medium-5"
          >Background <span class="text-gray">(375x812 pixel)</span></label
        >
        <div v-if="!formModal.isLayoutBgShow">
          <b-button
            class="btn-add-layout"
            @click="addLayout(showLayout.PRIVILEGE_BG)"
          >
            <div class="d-flex align-items-center justify-content-center">
              <add-icon /> <span class="ml-2">{{ "Add" }}</span>
            </div>
          </b-button>
        </div>
        <image-uploader
          v-else
          :image-url="formModal.backgroundImg.url"
          removable
          @onUpload="onUploadBg"
        />
      </b-col>
      <b-col v-if="formModal.templateSelect !== templateType.TYPE3">
        <label class="title-name mt-2 font-medium-5"
          >Logo <span class="text-gray">(345x40 pixel)</span></label
        >
        <div v-if="!formModal.isLayoutLogoShow">
          <b-button
            class="btn-add-layout"
            @click="addLayout(showLayout.PRIVILEGE_LOGO)"
          >
            <div class="d-flex align-items-center justify-content-center">
              <add-icon /> <span class="ml-2">{{ "Add" }}</span>
            </div>
          </b-button>
        </div>
        <image-uploader
          v-else
          :image-url="formModal.logoImg.url"
          removable
          @onUpload="onUploadLogo"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <color-code-pickr
          v-if="formModal.colorCode"
          title="Color Code"
          :model-value="formModal.colorCode"
          id="colorCode"
          @update:modelValue="(newValue) => (formModal.colorCode = newValue)"
        />
      </b-col>
      <b-col cols="6">
        <color-code-pickr
          v-if="formModal.colorCodeText"
          title="Color Text Code"
          :model-value="formModal.colorCodeText"
          id="colorCodeText"
          @update:modelValue="
            (newValue) => (formModal.colorCodeText = newValue)
          "
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import ColorCodePickr from "@/views/components/color-picker/ColorPickr.vue";
import ImageUploader from "@core/components/image-uploader/ImageUploader.vue";
import AddIcon from "@/@core/components/svg/button/Add.vue";
import VueQuillEditor, { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import useContentTemplate from "../hooks/useContentTemplate.js";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

import ImageCropper from "@/views/components/image-cropper/ImageCropper.vue";

export default {
  components: {
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
    quillEditor,
    ImageUploader,
    ColorCodePickr,
    AddIcon,
    Cropper,
    ImageCropper,
  },
  props: {
    formModal: { type: [Object, Array], default: {} },
    editorSelectId: null,
  },
  setup(props) {
    const {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      resolveDateObject,
      resolveDate,
      resolveTime,

      openChoosePrivilegeModal,
      closeChoosePrivilegeModal,
      onUploadBgImage,
      onUploadLogoImage,
      onUploadBg,
      onUploadLogo,
      addLayout,
      expireDate,
      onOpenExpireDatePicker,
      onSelectExpireDate,
      onOpenExpireTimePicker,
      onSelectExpireTimePicker,
      onFocus,
      customQuillOption,
      formatName,

      pageIndex,
      templateType,
      showLayout,
      expireType,
    } = useContentTemplate(props);

    return {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      resolveDateObject,
      resolveDate,
      resolveTime,

      openChoosePrivilegeModal,
      closeChoosePrivilegeModal,
      onUploadBgImage,
      onUploadLogoImage,

      onUploadBg,
      onUploadLogo,
      addLayout,
      expireDate,
      onOpenExpireDatePicker,
      onSelectExpireDate,
      onOpenExpireTimePicker,
      onSelectExpireTimePicker,
      onFocus,
      customQuillOption,
      formatName,

      pageIndex,
      templateType,
      showLayout,
      expireType,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/code-template-content.css";
.input-append-custom .input-group-text {
  border-top-right-radius: 0.8rem;
  border-bottom-right-radius: 0.8rem;
}

.cropper {
  height: 500px;
  background: #ddd;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
  background: #151515;
  cursor: pointer;
  transition: background 0.5s;
  border: none;
}

input.upload-image {
  display: none !important;
}
</style>
